/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors } from '../../../ui';
import { DropButton } from '../../../ui/DropButton';
import { useResolve } from '../../Container';
import { HelpController } from '../../core/help/HelpController';
import { HelpTip } from '../../core/help/HelpTip';
import { Flexer, Title } from '../../dashboard/elements/LayoutElements';
import { PreferencesModel } from '../../preferences/PreferencesModel';
import { Popover } from '../ui/Popover';
import { StatusIndicator } from './MeetingHeaderElements';
import { useActiveMeeting } from './MeetingHooks';
import { MeetingHostView } from './MeetingHostView';

const hostHaugTip = HelpTip(
    'hostInfo',
    'meetingHeader',
    'You\'re now a Meeting Host!',
    'As a host, you\'ll find a set of special controls in here that will help you manage and guide your meeting.  Click here to open the host menu.',
);

const ButtonLayout = () => {
    const meeting = useActiveMeeting();
    return <Flexer flex="row" align="center" gap=".625" color={Colors.primaryText}>
        <StatusIndicator active={!!meeting && !meeting.breakStart} />
        <Title flush size="lg" weight="400">
            {meeting && !meeting.breakStart && 'Meeting In Progress'}
            {meeting && !!meeting.breakStart && 'Meeting Paused'}
        </Title>
        <Icon size="1.25" src="deqo://icons/hero/chevron-down" />
    </Flexer>;
};

export const MeetingHostHeaderButton = () => {

    const haug = useResolve(HelpController);
    const preferences = useResolve(PreferencesModel);

    const [open, setOpen] = useState(false);
    const onToggle = () => setOpen(x => !x);

    useEffect(() => {
        if (!open) {
            preferences.haug && haug.openTip(hostHaugTip);
        }
        else {
            haug.dismissTip(hostHaugTip);
        }

    }, [open]);

    return <Popover
        content={<MeetingHostView onClose={() => setOpen(false)} />}
        inner={{
            direction: 'down',
            offset: '.5',
        }}
        open={open}
        onOpenChange={setOpen}
    >
        <DropButton data-action="editor.openMeetingMenu" active={open} rounding="full" padding=".5">
            <ButtonLayout />
        </DropButton>
    </Popover>;

};
